import type { TSerializedWidget } from 'src/entities/workspace/types';
import { extractAndStashReferenceWellsTree } from 'src/packages/reference-wells-persistence/extract-and-stash-reference-wells-tree';
import { parseTrajectoryWidgetInternalState } from 'src/pages/dashboard/features/trajectory-widget/parseTrajectoryWidget';
import { TrajectoryWidgetEntity } from 'src/pages/dashboard/features/trajectory-widget/TrajectoryWidget.entity';

export function mapTrajectoryWidget(widget: TSerializedWidget, index: number): TrajectoryWidgetEntity {
  const stripped = extractAndStashReferenceWellsTree(widget);
  const internalState = parseTrajectoryWidgetInternalState(stripped.internalState);

  return new TrajectoryWidgetEntity(
    {
      type: 'trajectory-widget',
      wellId: internalState.wellId ?? stripped.wellId ?? null,
      wellboreId: internalState.wellboreId,
      trajectoryId: internalState.trajectoryId,
      planOrFact: internalState.planOrFact,
      stateParams: internalState.stateParams,
    },
    {
      uuid: stripped.uuid,
      groupId: stripped.groupId,
      isPinned: !!stripped.isPinned,
      isFullscreen: stripped.isFullscreen,
      size: stripped.size,
      position: stripped.position,
      zIndex: 100 + index,
      isGroupsDefaultOpened: false,
    },
  );
}
